import { render, staticRenderFns } from "./technical-error.vue?vue&type=template&id=113d9b83&lang=pug"
import script from "./technical-error.vue?vue&type=script&setup=true&lang=js"
export * from "./technical-error.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports